<template>
    <el-container>
      <el-table :cell-class-name="cellClassName" :data="createTableData">
        <el-table-column prop="index" label="時間(24h)" width="110" />
        <el-table-column v-for="property in propertys" :key="property.prop" :prop="property.prop" :label="property.label" width="50" align="center" />
      </el-table>
    </el-container>
</template>

<script>

export default {
    props: {
        reportData: {
            type: Object,
            default: () => {},
            required: false
        },
        propertys: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    
    methods: {
      cellClassName({row, column, rowIndex, columnIndex}) { // eslint-disable-line no-unused-vars
            if(columnIndex==0){
                return 'header-cell';
            }
      }
    },
    
    data() {
        return {
            datasets: []
        }
    },

    computed: {
        createTableData() {

            let maxHoursData = {};
            let minHoursData = {};
            let densityHoursData = {};
            let densityLevelHousrsData = {};
            let hoursDataList = [];
            let prop_str = '';

            try {
                this.reportData.data_list.forEach((stream, index) => {
                    this.propertys.some((pp, idx) => {
                        if (index === idx + 1) {
                            prop_str = pp.prop
                            return true
                        } else if (index === 0) {
                            // propertys 最初の要素は、日付値のため
                            prop_str = "index"
                            return true
                        }
                    });
                    this.$set(maxHoursData, prop_str, stream.max)
                    this.$set(minHoursData, prop_str, stream.min)
                    this.$set(densityHoursData, prop_str, stream.density)
                    this.$set(densityLevelHousrsData, prop_str, stream.density_level)
                });
                hoursDataList.push(maxHoursData);
                hoursDataList.push(minHoursData);
                hoursDataList.push(densityHoursData);
                hoursDataList.push(densityLevelHousrsData);

            } catch (e) {
                console.log(e)
            }
            return hoursDataList
                
        },
    },
};

</script>

<style scoped>
    .el-table >>> th, .el-table >>> .header-cell{
        color: dimgray;
        background-color: lightsteelblue;
    }

</style>